/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable no-param-reassign */
import {defaults} from './config.defaults'

export const embedDefault = {
    ...defaults.theme,
    // define all default embed specific variables here
    backgroundSizes: {...defaults.theme.backgroundSizes},
    colors: {
        ...defaults.theme.colors,

        floatingEmbedHeader: '#0046AD',
        floatingEmbedHeaderBorder: 'transparent',
        floatingEmbedHeaderTitle: '#FFFFFF',
        floatingEmbedHeaderIcon: '#FFFFFF',
        floatingEmbedHeaderSubtitle: '#FFFFFFCC',
        floatingEmbedHeaderButton: '#FFFFFF',
        floatingEmbedHeaderButtonIcon: '#FFFFFF',
        floatingEmbedHeaderButtonHover: '#FFFFFF',
        floatingEmbedHeaderButtonIconHover: '#FFFFFF',
        floatingEmbedHeaderButtonBackground: 'transparent',
        floatingEmbedHeaderButtonBorder: 'transparent',
        floatingEmbedHeaderButtonHoverBackground: '#346bbd',
        floatingEmbedHeaderButtonFocusBackground: '#00388a',
        floatingEmbedHeaderButtonActiveOutline: '#ffffff',
        floatingEmbedHeaderAvatar: '#FFFFFF',
        floatingEmbedHeaderAvatarBackground: '#0046AD',
        floatingEmbedHeaderAvatarBorder: '#FFFFFF',

        floatingEmbedBall: '#0046AD',
        floatingEmbedBallHover: '#008AFF',
        floatingEmbedBallActive: '#00337D',
        floatingEmbedBallText: '#FFFFFF',
        floatingEmbedBallTextHover: '#FFFFFF',

        floatingEmbedPromoBubble: '#FFFFFF',
        floatingEmbedPromoBubbleText: '#000000',

        containerEmbedHeader: '#0046AD',
        containerEmbedHeaderBorder: 'transparent',
        containerEmbedHeaderTitle: '#FFFFFF',
        containerEmbedHeaderIcon: '#FFFFFF',
        containerEmbedHeaderSubtitle: '#FFFFFFCC',
        containerEmbedHeaderAvatar: '#FFFFFF',
        containerEmbedHeaderAvatarBorder: '#FFFFFF',

        containerEmbedHeaderButton: '#FFFFFF',
        containerEmbedHeaderButtonIcon: '#FFFFFF',
        containerEmbedHeaderButtonHover: '#FFFFFF',
        containerEmbedHeaderButtonIconHover: '#FFFFFF',
        containerEmbedHeaderButtonBackground: 'transparent',
        containerEmbedHeaderButtonBorder: 'transparent',
        containerEmbedHeaderButtonHoverBackground: '#346bbd',
        containerEmbedHeaderButtonFocusBackground: '#00388a',
        containerEmbedHeaderButtonActiveOutline: '#ffffff',

        containerEmbedHeaderCloseButton: '$containerEmbedHeaderButton',
        containerEmbedHeaderCloseButtonIcon: '$containerEmbedHeaderIcon',
        containerEmbedHeaderCloseButtonHover: '$containerEmbedHeaderButtonHover',
        containerEmbedHeaderCloseButtonBackground: '$containerEmbedHeaderButtonBackground',
        containerEmbedHeaderCloseButtonBorder: '$containerEmbedHeaderButtonBorder',
        containerEmbedHeaderCloseButtonHoverBackground: '$containerEmbedHeaderButtonHoverBackground',
        containerEmbedHeaderCloseButtonIconHover: '$containerEmbedHeaderButtonIconHover',
        containerEmbedHeaderCloseButtonFocusBackground: '$containerEmbedHeaderButtonFocusBackground',
        containerEmbedHeaderCloseButtonActiveOutline: '$containerEmbedHeaderButtonActiveOutline',

        containerEmbedHeaderTitleButtonTitle: '$containerEmbedHeaderTitle',
        containerEmbedHeaderTitleButtonSubtitle: '$containerEmbedHeaderSubtitle',
        containerEmbedHeaderTitleButtonTitleHover: '$containerEmbedHeaderTitle',
        containerEmbedHeaderTitleButtonSubtitleHover: '$containerEmbedHeaderSubtitle',
        containerEmbedHeaderTitleButtonBackground: '$containerEmbedHeaderButtonBackground',
        containerEmbedHeaderTitleButtonBorder: '$containerEmbedHeaderButtonBorder',
        containerEmbedHeaderTitleButtonHoverBackground: '$containerEmbedHeaderButtonHoverBackground',
        containerEmbedHeaderTitleButtonFocusBackground: '$containerEmbedHeaderButtonFocusBackground',
        containerEmbedHeaderTitleButtonActiveOutline: '$containerEmbedHeaderButtonActiveOutline',

        embedBody: '#0F243D',
        embedBodyBackground: '#FFFFFF',
        embedBodyHeading1: '#0F243D',
        embedBodyHeading2: '#0F243D',
        embedBodyHeading3: '#0F243D',
        embedBodyHeading4: '#0F243D',
        embedBodyHeading5: '#0F243D',
        embedBodyHeading6: '#0F243D',
        embedErrorTitle: '#0046AD',
        embedHeadingHighlighted: '#0046AD',

        embedHeroBackground: '#0046AD',
        embedHeroBorder: '#0046AD',
        embedHero: '#FFFFFF',
        embedHeroSubtitle: 'rgba(255, 255, 255, 0.8)',
        embedHeroSubtitleInQueue: 'rgba(255, 255, 255, 0.8)',
        embedHeroTitle: '#FFFFFF',
        embedHeroTitleInQueue: '#FFFFFF',
        embedHeroAvatar: '#FFFFFF',
        embedHeroAvatarBackground: '$embedHeroBackground',
        embedHeroAvatarBorder: '#FFFFFF',
        embedHeroErrorTitle: '#FFFFFF',
        embedHeroErrorMessage: '#FFFFFF',
        embedQueuePosition: '#FFFFFF',
        embedQueueSpinner: '#FFFFFF',

        questionnaireErrorTitle: '#0046AD',

        questionnaireRadioBackground: '$buttonBackground',
        questionnaireRadioBorder: '$buttonBorder',
        questionnaireRadioText: '$buttonText',
        questionnaireRadioFocusOutline: '$buttonOutlineFocus',

        questionnaireRadioTextSelected: '#FFFFFF',
        questionnaireRadioBorderSelected: '$buttonBorder',
        questionnaireRadioBackgroundSelected: '#38516E',

        questionnaireNavigation: '#F1F1F1',
        questionnaireEmojiGood: '#0046AD',
        questionnaireEmojiAverageGood: '#9DB91E',
        questionnaireEmojiAverage: '#DCCD00',
        questionnaireEmojiAverageBad: '#D37400',
        questionnaireEmojiBad: '#D93939',

        messageSpeechBubbleOther: '#112337',
        messageSpeechBubbleOtherText: '#FFFFFF',

        questionnaireLightBotBubbleBackground: '$messageSpeechBubbleOperatorModerator',
        questionnaireLightBotBubbleBorder: '$messageSpeechBubbleOperatorModeratorBorder',
        questionnaireLightBotBubbleText: '$messageSpeechBubbleOperatorModeratorText',
        questionnaireLightBotUsername: '$messageUsernameOperatorModerator',

        questionnaireLightBotAnswerBubbleBackground: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubbleBorder: '#112337',
        questionnaireLightBotAnswerBubbleText: '$messageSpeechBubbleOtherText',
        questionnaireLightBotAnswerBubbleLabel: '#B2C2D5',

        questionnaireLink: '#0046AD',
        questionnaireLinkHover: '#002F6C',

        embedModalIcon: '#0046AD',

        skeletonLoader: '#000000',
        skeletonLoaderBackground: 'rgba(176, 208, 254, 0.8)',
        skeletonLoaderProgress: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.85) 25%, rgba(255, 255, 255, 0.85) 75%, rgba(255, 255, 255, 0) 100%)',

        floatingEmbed: '#FFFFFF',
        floatingEmbedClose: '#DEDEDE',
        floatingEmbedCloseIcon: '#7e95af',
        floatingEmbedVideoBall: '#D30000',
        floatingEmbedConversationBall: '#008AFF',

        questionnaireEmoji: '#FFFFFF',
        questionnaireEmojiBackground: '#FFFFFF',
        questionnaireNpsBackground: '#FFFFFF',
        questionnaireNpsBorder: '#B2C2D5',
        questionnaireNpsLabel: '#7E95AF',
        questionnaireNpsSelectedBackground: '#38516E',
        questionnaireNpsSelected: '#FFFFFF',
        questionnaireErrorBackground: '#FFEDED',
        questionnaireErrorGroupText: '#112337',
        questionnaireErrorText: '#D93939',

        questionnaireLabel: 'inherit',
        questionnaireDescription: '#7E95AF',

        questionnaireFileIcon: '#008AFF',

        embedChatHeaderOnVideoBorder: '#B2C2D5',
        embedModalHeader: '#0046AD',
        questionnaireSsoIcon: '#7E95AF',
        questionnaireSsoIconError: '$alertIconError',
        questionnaireSsoIconSuccess: '$alertIconSuccess',

        // button embed send
        buttonSendBackground: '#112337',
        buttonSendBackgroundActive: '#38516E',
        buttonSendBackgroundDisabled: '#B2C2D5',
        buttonSendBackgroundFocus: '#008AFF',
        buttonSendBackgroundHover: '#38516E',
        buttonSendBorder: '#112337',
        buttonSendBorderActive: '#38516E',
        buttonSendBorderDisabled: '#B2C2D5',
        buttonSendBorderFocus: '#008AFF',
        buttonSendBorderHover: '#38516E',
        buttonSendIcon: '#B2C2D5',
        buttonSendIconDisabled: '#E7ECF1',
        buttonSendIconFocus: '#FFFFFF',
        buttonSendIconActive: '#889DAE',
        buttonSendIconHover: '#889DAE',
        buttonSendText: '#FFFFFF',
        buttonSendTextDisabled: '#FFFFFF',
        buttonSendTextActive: '#FFFFFF',
        buttonSendTextFocus: '#FFFFFF',
        buttonSendTextHover: '#FFFFFF',
        buttonSendOutlineFocus: '#008AFF',

        // button command bar
        buttonCommandBarBorder: 'transparent',
        buttonCommandBarBorderDisabled: 'transparent',
        buttonCommandBarBorderActive: '#7E95AF',
        buttonCommandBarBorderFocus: '#7E95AF',
        buttonCommandBarBorderHover: '#e8eaec',

        // button video
        buttonVideoBackground: '#1EB960',
        buttonVideoBackgroundActive: '#1EB960',
        buttonVideoBackgroundDisabled: '#B2C2D5',
        buttonVideoBackgroundFocus: '#1EB960',
        buttonVideoBackgroundHover: '#1EB960',
        buttonVideoBorder: '#1EB960',
        buttonVideoBorderActive: '#1EB960',
        buttonVideoBorderDisabled: '#B2C2D5',
        buttonVideoBorderFocus: '##1EB960',
        buttonVideoBorderHover: '#1EB960',
        buttonVideoIcon: '#B2C2D5',
        buttonVideoIconDisabled: '#E7ECF1',
        buttonVideoIconFocus: '#FFFFFF',
        buttonVideoIconActive: '#889DAE',
        buttonVideoIconHover: '#889DAE',
        buttonVideoText: '#FFFFFF',
        buttonVideoTextDisabled: '#FFFFFF',
        buttonVideoTextActive: '#FFFFFF',
        buttonVideoTextFocus: '#FFFFFF',
        buttonVideoTextHover: '#FFFFFF',
        buttonVideoOutlineFocus: '#FFFFFF',

        // button new messages
        newMessagesBackground: '#008AFF',
        newMessagesText: '#FFFFFF',
        newMessagesIcon: '#FFFFFF',

        // attachments
        questionnaireAttachmentItemBackground: '#F9FBFE',
        questionnaireAttachmentItemBackgroundHover: '#e8eaec',
        questionnaireAttachmentValid: '#1EB960',
        questionnaireAttachmentInvalid: '#D30000',

        // dropdown
        dropdownBackground: '#FFFFFF',
        dropdownBorder: '#DEDEDE',
        dropdownItemBackgroundHover: '#E8EAEC',
    },
    borderWidths: {
        ...defaults.theme.borderWidths,
        embedHero: '1px',
        containerEmbedHeaderBorder: '1px',
        floatingEmbedHeaderBorder: '1px',
        containerEmbedHeaderButton: '1px',
        floatingEmbedHeaderButton: '1px',
        containerEmbedHeaderTitleButton: '$containerEmbedHeaderButton',
        containerEmbedHeaderCloseButton: '$containerEmbedHeaderButton',
        buttonSend: '1px',
        buttonVideo: '1px',
        buttonCommandBar: '1px',
        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    borderStyles: {
        ...defaults.theme.borderStyles,
        embedHero: 'solid',
        containerEmbedHeaderBorder: 'solid',
        floatingEmbedHeaderBorder: 'solid',
        containerEmbedHeaderButton: 'solid',
        floatingEmbedHeaderButton: 'solid',
        containerEmbedHeaderTitleButton: '$containerEmbedHeaderButton',
        containerEmbedHeaderCloseButton: '$containerEmbedHeaderButton',
        buttonSend: 'solid',
        buttonVideo: 'solid',
        buttonCommandBar: 'solid',
        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    fonts: {
        ...defaults.theme.fonts,

        floatingEmbedHeaderTitle: 'inherit',
        floatingEmbedHeaderSubtitle: 'inherit',
        floatingEmbedBall: 'inherit',
        floatingEmbedHeaderButton: 'inherit',
        floatingEmbedPromoBubble: 'inherit',

        containerEmbedHeaderTitle: 'inherit',
        containerEmbedHeaderSubtitle: 'inherit',
        containerEmbedHeaderButton: 'inherit',

        embedBody: '"Open Sans", sans-serif',
        embedBodyHeading1: 'inherit',
        embedBodyHeading2: 'inherit',
        embedBodyHeading3: 'inherit',
        embedBodyHeading4: 'inherit',
        embedBodyHeading5: 'inherit',
        embedBodyHeading6: 'inherit',

        questionnaireLink: 'inherit',

        embedHero: 'inherit',
        embedHeroTitle: 'inherit',
        embedHeroAvatar: 'inherit',
        embedHeroTitleInQueue: 'inherit',
        embedHeroSubtitle: 'inherit',
        embedHeroSubtitleInQueue: 'inherit',
        embedHeroErrorTitle: 'inherit',
        embedHeroErrorMessage: 'inherit',

        embedModalHeader: 'inherit',

        buttonSend: 'inherit',
        buttonVideo: 'inherit',

        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    fontStyle: {
        ...defaults.theme.fontStyle,
        embedBody: 'normal',
        embedBodyHeading1: 'normal',
        embedBodyHeading2: 'normal',
        embedBodyHeading3: 'normal',
        embedBodyHeading4: 'normal',
        embedBodyHeading5: 'normal',
        embedBodyHeading6: 'normal',

        questionnaireLink: 'normal',
        questionnaireLabel: 'inherit',
        questionnaireDescription: 'inherit',

        embedHero: 'normal',
        embedHeroTitle: 'normal',
        embedHeroAvatar: 'normal',
        embedHeroSubtitle: 'normal',
        embedHeroTitleInQueue: 'normal',
        embedHeroSubtitleInQueue: 'normal',
        embedHeroErrorTitle: 'normal',
        embedHeroErrorMessage: 'normal',

        embedModalHeader: 'normal',

        buttonSend: 'normal',
        buttonVideo: 'normal',

        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',

    },
    fontVariant: {
        ...defaults.theme.fontVariant,

        embedBody: 'normal',
        embedBodyHeading1: 'normal',
        embedBodyHeading2: 'normal',
        embedBodyHeading3: 'normal',
        embedBodyHeading4: 'normal',
        embedBodyHeading5: 'normal',
        embedBodyHeading6: 'normal',

        questionnaireLink: 'normal',
        questionnaireLabel: 'inherit',
        questionnaireDescription: 'inherit',

        embedHero: 'normal',
        embedHeroTitle: 'normal',
        embedHeroAvatar: 'normal',
        embedHeroSubtitle: 'normal',
        embedHeroTitleInQueue: 'normal',
        embedHeroSubtitleInQueue: 'normal',
        embedHeroErrorTitle: 'normal',
        embedHeroErrorMessage: 'normal',

        embedModalHeader: 'normal',

        buttonSend: 'normal',
        buttonVideo: 'normal',

        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    radii: {
        ...defaults.theme.radii,

        floatingEmbed: '8px',
        floatingEmbedBall: '32px',
        floatingEmbedPromoBubble: '12px',

        floatingEmbedHeaderButton: '4px',
        containerEmbedHeaderButton: '4px',

        containerEmbedHeaderTitleButton: '$containerEmbedHeaderButton',
        containerEmbedHeaderCloseButton: '$containerEmbedHeaderButton',

        embedHero: '10px',

        buttonSend: '6px',
        buttonVideo: '6px',
        buttonCommandBar: '6px',

        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    fontSizes: {
        ...defaults.theme.fontSizes,

        floatingEmbedHeaderTitle: '16px',
        floatingEmbedHeaderSubtitle: '14px',
        floatingEmbedBall: '16px',
        floatingEmbedBallState: '20px',
        floatingEmbedHeaderButton: '14px',
        floatingEmbedPromoBubble: '16px',
        floatingEmbedHeaderInQueueLoader: '16px',
        floatingEmbedHeaderAvatar: '16px',

        containerEmbedHeaderTitle: '16px',
        containerEmbedHeaderSubtitle: '14px',
        containerEmbedHeaderButton: '14px',
        containerEmbedHeaderAvatar: '16px',

        embedBody: '15px',
        embedBodyHeading1: '2em',
        embedBodyHeading2: '1.5em',
        embedBodyHeading3: '1.17em',
        embedBodyHeading4: '1em',
        embedBodyHeading5: '0.83em',
        embedBodyHeading6: '0.67em',
        embedHero: '16px',
        embedHeroTitle: '16px',
        embedHeroAvatar: '16px',
        embedHeroTitleInQueue: '16px',
        embedHeroSubtitle: '14px',
        embedHeroSubtitleInQueue: '14px',
        embedHeroErrorTitle: '16px',
        embedHeroErrorMessage: '16px',

        embedModalHeader: '20px',

        questionnaireLink: 'inherit',
        questionnaireLabel: '14px',
        questionnaireDescription: 'inherit',

        questionnaireLightBotUsername: '14px',
        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',

        buttonSend: '14px',
        buttonVideo: '14px',

        skeletonLoader: '14px',

        // not possible to override
        lightBoxFileSize: '12px',
    },
    fontWeights: {
        ...defaults.theme.fontWeights,

        floatingEmbedHeaderTitle: 700,
        floatingEmbedHeaderSubtitle: 400,
        floatingEmbedBall: 400,
        floatingEmbedHeaderButton: 400,
        containerEmbedHeaderTitle: 700,
        containerEmbedHeaderSubtitle: 400,
        containerEmbedHeaderButton: 400,

        embedBody: 400,
        embedBodyHeading1: 700,
        embedBodyHeading2: 700,
        embedBodyHeading3: 700,
        embedBodyHeading4: 700,
        embedBodyHeading5: 700,
        embedBodyHeading6: 700,
        embedBodyBold: 700,

        embedModalHeader: 700,

        questionnaireLink: 'inherit',
        questionnaireLabel: '600',
        questionnaireDescription: '600',

        embedHero: 400,
        embedHeroSubtitle: 400,
        embedHeroSubtitleInQueue: 400,
        embedHeroTitle: 700,
        embedHeroAvatar: 700,
        embedHeroTitleInQueue: 700,
        embedHeroErrorTitle: 700,
        embedHeroErrorMessage: 400,

        buttonSend: 400,
        buttonVideo: 400,

        skeletonLoader: 400,

        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    lineHeights: {
        ...defaults.theme.lineHeights,
        embedBody: 'normal',
        embedBodyHeading1: 'normal',
        embedBodyHeading2: 'normal',
        embedBodyHeading3: 'normal',
        embedBodyHeading4: 'normal',
        embedBodyHeading5: 'normal',
        embedBodyHeading6: 'normal',
        embedHero: 'normal',
        embedHeroTitle: 'normal',
        embedHeroAvatar: 'normal',
        embedHeroTitleInQueue: 'normal',
        embedHeroSubtitle: 'normal',
        embedHeroSubtitleInQueue: 'normal',
        embedHeroErrorTitle: 'normal',
        embedHeroErrorMessage: 'normal',

        embedModalHeader: 'normal',

        buttonSend: 'normal',
        buttonVideo: 'normal',
        questionnaireLightBotBubble: '$messageSpeechBubbleOther',
        questionnaireLightBotAnswerBubble: '$messageSpeechBubbleOperatorModerator',
    },
    space: {
        ...defaults.theme.space,
        embedHero: '20px',
        button: '5px 8px',
        buttonSend: '5px',
        buttonSendMargin: '0',
        buttonVideo: '5px 8px',
        buttonCommandBar: '5px',
        buttonCommandBarMargin: '0',
        inQueueText: '20px 0 0',
        input: '6px 8px',
        inputModal: '6px 8px',
        embedHeroTitle: '0',
        embedHeroTitleInQueue: '0',
        embedHeroSubtitle: '0',
        embedHeroSubtitleInQueue: '0',
        embedHeroErrorTitle: '0 0 10px',
        embedHeroErrorMessage: '0',
        floatingEmbedHeaderButton: '5px',
        containerEmbedHeaderButton: '5px',
        containerEmbedHeaderTitleButton: '$containerEmbedHeaderButton',
        containerEmbedHeaderCloseButton: '$containerEmbedHeaderButton',
        floatingEmbedHeader: '10px',
        containerEmbedHeader: '10px',
        floatingEmbedBall: '20px',
        messageSpeechBubbleOperatorModerator: '5px 10px',
        messageSpeechBubbleOther: '5px 10px',
    },
    zIndices: {
        ...defaults.theme.zIndices,

        floatingEmbedBall: 1000,
        floatingEmbed: 1000,
        containerHeader: 500,

        newMessagesVideoButton: 108,
        embedModal: '$containerHeader',
        heroFullAbsolute: 500,
        headerDropdown: 100,
    },
    shadows: {
        ...defaults.theme.shadows,
        floatingEmbed: '0px 4px 40px 0px #00000040',
        floatingEmbedBall: '0px 4px 40px 0px #00000040',
        floatingEmbedPromoBubble: '0px 10px 15px 0px #00000033',
        dropdownShadow: '0px 4px 10px 0px #00000033',
    },
    sizes: {
        ...defaults.theme.sizes,
        embedQueueSpinner: '60px',
        embedHeroAvatar: '80px',
        floatingEmbedHeaderInQueueLoader: '25px',
        floatingEmbedHeaderVideoIcon: '25px',
        floatingEmbedHeaderNewMessageIcon: '25px',
        floatingEmbedBallInQueueLoader: '40px',
        floatingEmbedBallVideoIcon: '40px',
        floatingEmbedBallNewMessageIcon: '40px',
        floatingEmbedHeaderAvatar: '30px',
        containerEmbedHeaderAvatar: '30px',
        chatTextareaMaxHeight: '250px',
    },
} as any

export const embedDarkDefault = {
    ...embedDefault,
    colors: {
        ...embedDefault.colors,
        embedBody: '#FFFFFF',
        embedBodyBackground: '#191E23',
        embedBodyHeading1: '#FFFFFF',
        embedBodyHeading2: '#FFFFFF',
        embedBodyHeading3: '#FFFFFF',
        embedBodyHeading4: '#FFFFFF',
        embedBodyHeading5: '#FFFFFF',
        embedBodyHeading6: '#FFFFFF',
    },
}

